"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRoles = exports.FirestoreInviteUser = exports.FirestoreUser = void 0;
const obejct_diff_1 = require("../utils/obejct-diff");
class FirestoreUser {
    ; // Titel; title
    constructor() {
        this.displayName = undefined;
        this.identifier = undefined;
        this.contextId = undefined;
        this.email = undefined;
        this.roles = undefined;
        this.updateTimestamp = undefined;
        this.creationDate = undefined;
        this.firstName = undefined; // Vorname; Firstname
        this.lastName = undefined; // Nachname; Lastname
        this.gender = undefined; // (m / f / d) // (m / w / d)
        this.salutation = undefined; // Anrede, Salutation
        this.title = undefined;
        this.legalAddress = undefined;
        this.telephone = undefined;
        this.signature = undefined;
        this.invitationState = undefined;
        this.language = undefined;
        this.oobCode = undefined;
        this.contextMembership = undefined;
        this.contextIds = undefined;
        this.userGroupIds = undefined;
        this.selectedContextId = undefined;
    }
    setFromAny(element) {
        const { displayName, identifier, contextId, email, roles, updateTimestamp, creationDate, firstName, lastName, gender, salutation, title, legalAddress, telephone, signature, invitationState, language, oobCode, contextMembership, contextIds, userGroupIds, selectedContextId } = element;
        this.identifier = identifier ? identifier : this.identifier;
        this.contextId = contextId ? contextId : this.contextId;
        this.email = email !== null && email !== void 0 ? email : this.email;
        this.creationDate = creationDate ? (0, obejct_diff_1.isDate)(creationDate) ? creationDate : (0, obejct_diff_1.firestoreTimestampToDate)(creationDate) : this.creationDate;
        this.updateTimestamp = updateTimestamp ? (0, obejct_diff_1.isDate)(updateTimestamp) ? updateTimestamp : (0, obejct_diff_1.firestoreTimestampToDate)(updateTimestamp) : this.updateTimestamp;
        this.roles = roles !== null && roles !== void 0 ? roles : this.roles;
        this.displayName = displayName !== null && displayName !== void 0 ? displayName : this.displayName;
        this.firstName = firstName ? firstName : this.firstName;
        this.lastName = lastName ? lastName : this.lastName;
        this.gender = gender ? gender : this.gender;
        this.salutation = salutation ? salutation : this.salutation;
        this.title = title ? title : this.title;
        this.legalAddress = legalAddress ? legalAddress : this.legalAddress;
        this.telephone = telephone ? telephone : this.telephone;
        this.signature = signature ? signature : this.signature;
        this.invitationState = invitationState ? invitationState : this.invitationState;
        this.language = language ? language : this.language;
        this.oobCode = oobCode ? oobCode : this.oobCode;
        this.contextMembership = contextMembership ? contextMembership : undefined;
        this.contextIds = contextIds ? contextIds : undefined;
        this.userGroupIds = userGroupIds ? userGroupIds : undefined;
        this.selectedContextId = selectedContextId ? selectedContextId : undefined;
    }
    static setFromAny(element) {
        const user = new FirestoreUser();
        user.setFromAny(element);
        return user;
    }
    searchFilter(filter) {
        const str = `${this.displayName}${this.email}`.toLowerCase();
        return str.includes(filter);
    }
    toString() {
        return JSON.stringify(this);
    }
}
exports.FirestoreUser = FirestoreUser;
class FirestoreInviteUser {
    constructor() {
        this.language = undefined;
        this.email = undefined;
        this.roles = undefined;
        this.contextId = undefined;
        this.displayName = undefined;
        this.updateTimestamp = undefined;
        this.creationDate = undefined;
        this.invitationState = undefined;
        this.registrationLink = undefined;
        this.oobCode = undefined;
        this.identifier = undefined;
    }
    setFromAny(element) {
        const { identifier, contextId, email, roles, updateTimestamp, creationDate, } = element;
        this.identifier = identifier ? identifier : this.identifier;
        this.contextId = contextId ? contextId : this.contextId;
        this.email = email !== null && email !== void 0 ? email : this.email;
        this.creationDate = creationDate ? (0, obejct_diff_1.isDate)(creationDate) ? creationDate : (0, obejct_diff_1.firestoreTimestampToDate)(creationDate) : this.creationDate;
        this.updateTimestamp = updateTimestamp ? (0, obejct_diff_1.isDate)(updateTimestamp) ? updateTimestamp : (0, obejct_diff_1.firestoreTimestampToDate)(updateTimestamp) : this.updateTimestamp;
        this.roles = roles !== null && roles !== void 0 ? roles : this.roles;
    }
    static setFromAny(element) {
        const user = new FirestoreInviteUser();
        user.setFromAny(element);
        return user;
    }
    // searchFilter(filter: string): boolean {
    //     const str = `${this.displayName}${this.email}`.toLowerCase()
    //     return str.includes(filter)
    // }
    toString() {
        return JSON.stringify(this);
    }
}
exports.FirestoreInviteUser = FirestoreInviteUser;
var UserRoles;
(function (UserRoles) {
    UserRoles["ANSTELLER"] = "ansteller";
    UserRoles["JAGDLEITER"] = "jagdleiter";
    UserRoles["USER"] = "user";
    UserRoles["HUNTER"] = "hunter";
    UserRoles["REVIERLEITER"] = "revierLeiter";
    UserRoles["RECORDER"] = "recorder";
    UserRoles["APPVET"] = "applicantVet";
    UserRoles["VETHDLEADER"] = "veterinaryHuntingDistrictLeader";
    UserRoles["ADMIN"] = "admin";
    UserRoles["CADAVERSEEK"] = "wsvgKadaverSucher";
    UserRoles["CADAVERBT"] = "wsvgKadaverBergeTeam";
    UserRoles["STAFF"] = "wsvgSonstigerMitarbeiter";
    UserRoles["SENIOR"] = "wsvgLeitenderMitarbeiter";
})(UserRoles || (exports.UserRoles = UserRoles = {}));
